module.exports = __webpack_public_path__ + "media/images/wf_logo.3-9db2c1e5119f44b43cb68525533e5723.png";